import React from 'react';

import {Text, View} from 'react-native';

import {BodyText} from 'src/Modules/CommonView';
import FontAwesomeIcon from 'react-native-vector-icons/FontAwesome';
import {useLocation} from '../../Hooks/gameHooks';
import {calculateDistance} from '../../Utils/distanceHelpers';
import {useSelector} from 'react-redux';
export const DistanceAway = ({style = {}, textOnly}) => {
  const location = useLocation();

  const locationLat = parseFloat(location?.lat);
  const locationLong = parseFloat(location?.long);

  const region = useSelector((state) => state.location?.region) || {};
  const {latitude = 0, longitude = 0} = region;

  const userLat = parseFloat(latitude);
  const userLong = parseFloat(longitude);

  const distanceAway = calculateDistance(
    locationLat,
    locationLong,
    userLat,
    userLong,
    'FEET',
  );

  console.log('DistanceAway', {
    distanceAway,
    locationLat,
    locationLong,
    userLat,
    userLong,
  });

  if (!location?.lat) {
    return <View></View>;
  }

  const formattedDistanceAway =
    distanceAway <= 0.0001
      ? `Error`
      : distanceAway > 5280
      ? `${Math.round((100 * distanceAway) / 5280) / 100} mi away`
      : `${Math.round(distanceAway)} ft away`;

  if (textOnly) {
    return (
      <Text style={{color: 'white', fontFamily: 'JakartaBold', fontSize: 14}}>
        {formattedDistanceAway}
      </Text>
    );
  }

  return (
    <View
      style={{
        backgroundColor: global?.color?.gray3,
        paddingHorizontal: 5,
        paddingVertical: 5,
        position: 'absolute',
        top: 10,
        left: 10,
        ...style,
      }}>
      <BodyText
        textStyle={{
          color: global?.color?.white,
          fontWeight: '700',
          fontSize: 14,
          marginTop: 0,
          textAlign: 'center',
        }}>
        <FontAwesomeIcon name={'search'} size={12} color={'white'} />
        {formattedDistanceAway}
      </BodyText>
    </View>
  );
};
